!function() {
  "use strict";
  customElements.get("review-product") || customElements.define("review-product", class extends HTMLElement {
    constructor() {
      super(), this.sku = this.getAttribute("data-sku") || "", this.ratingNumberEl = this.querySelector("[data-rating-number]"), 
      this.ratingStarsEl = this.querySelector("[data-rating-stars]"), this.ratingCountEl = this.querySelector("[data-rating-count]"), 
      this.ratingTextEl = this.querySelector("[data-rating-text]");
    }
    async connectedCallback() {
      if (window.Shopify?.app_config?.reviews_io?.store && this.sku.trim()) try {
        const t = await fetch(`https://api.reviews.io/product/rating-batch?store=${window.Shopify.app_config.reviews_io.store}&sku=${this.sku}`, {
          headers: {
            accept: "application/json"
          }
        });
        if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
        const e = await t.json();
        let i = 0, r = 0;
        Array.isArray(e) && ({totalRatings: i, ratingCount: r} = e.reduce(((t, e) => ({
          totalRatings: t.totalRatings + parseFloat(e.average_rating || 0) * parseInt(e.num_ratings || 0),
          ratingCount: t.ratingCount + parseInt(e.num_ratings || 0)
        })), {
          totalRatings: 0,
          ratingCount: 0
        }));
        const s = t => {
          const e = String(t);
          if (e.includes(".")) {
            const [t, i] = e.split(".");
            return i.length > 1 ? `${t}.${i.slice(0, 1)}` : e;
          }
          return e;
        }, n = parseFloat((i / r).toFixed(2)) || 0;
        if (0 === n) return void (this.style.display = "none");
        [ n && this.ratingNumberEl && (this.ratingNumberEl.textContent = s(n)), n && this.ratingStarsEl && (this.ratingStarsEl.style.width = 20 * n + "%"), r && this.ratingCountEl && (this.ratingCountEl.textContent = r.toLocaleString()) ].some(Boolean) && (this.ratingTextEl && (this.ratingTextEl.textContent = r > 1 ? window.strings?.review?.other : window.strings?.review?.one), 
        setTimeout((() => this.classList.remove("opacity-0", "pointer-events-none")), 100));
      } catch (t) {
        console.error("Error fetching product review stats:", t);
      }
    }
  });
}();